import React from 'react';
import { UniverseModuleType } from 'src/domains/common/universes.type';
import { features } from './gentlemanjim.features';
import { themeColors } from './gentlemanjim.config';
import { GentlemanjimLogotype } from './gentlemanjim.logotype';
import { GentlemanJimLogo } from 'src/layouts/LoginPage/logos/GentlemanJimLogo';
import GentlemanJimLoginImage from 'src/layouts/LoginPage/loginBgImages/GentlemanJimLoginImage.jpg';
import { GentleManJimBrandIconWrapper } from './gentlemanjim.style';
import { LoginImageWrapper } from 'src/layouts/LoginPage/LoginImage.style';

export const universeModule: UniverseModuleType = {
    themeColors,
    features,
    title: 'Gentleman Jim Backoffice',
    urls: {
        website: 'https://gentlemanjim.bet/',
        backoffice: 'https://backoffice.gentlemanjim.bet/',
    },
    BrandIcon: () => <GentleManJimBrandIconWrapper />,
    Logotype: () => <GentlemanjimLogotype />,
    LogotypeLoginPage: () => <GentlemanJimLogo />,
    compliancePopupLogo: null,
    loginImageContainer: () => <LoginImageWrapper imgSrc={GentlemanJimLoginImage} />,
};
